<template>
  <div class="stepper">
    <div
      class="stepper__step"
      :class="{ 'is-done': step > 1, 'is-active': step === 1 }"
    >
      <div class="">
        <img src="@/assets/img/return/refund_on.svg" alt />
      </div>
      <div class="stepper__step__label">{{ `1.退${word}原因` }}</div>
    </div>
    <div class="stepper__divider" :class="{ 'is-pass': step > 1 }" />
    <div
      class="stepper__step"
      :class="{ 'is-done': step > 2, 'is-active': step === 2 }"
    >
      <div class="">
        <img src="@/assets/img/return/policy_on.svg" alt v-if="step >= 2" />
        <img src="@/assets/img/return/policy_off.png" alt v-else />
      </div>
      <div class="stepper__step__label">{{ `2.退${word}條款` }}</div>
    </div>
    <div
      class="stepper__divider"
      :class="{ 'is-pass': step > 2 }"
      v-if="isAtmRefund"
    />
    <div
      class="stepper__step"
      :class="{ 'is-done': step > 3, 'is-active': step === 3 }"
      v-if="isAtmRefund"
    >
      <div class="">
        <img src="@/assets/img/return/bank_on.svg" alt v-if="step >= 3" />
        <img src="@/assets/img/return/bank_off.png" alt v-else />
      </div>
      <div class="stepper__step__label">3.匯款資訊</div>
    </div>
    <div
      class="stepper__divider"
      :class="{ 'is-pass': step > 3, 'is-empty': step < 3 }"
    />
    <div
      class="stepper__step"
      :class="{ 'is-done': step > 4, 'is-active': step === 4 }"
    >
      <div class="">
        <img src="@/assets/img/return/docSend_on.svg" alt v-if="step >= 4" />
        <img src="@/assets/img/return/docSend_off.png" alt v-else />
      </div>
      <div class="stepper__step__label">
        {{ isAtmRefund ? 4 : 3 }}.退{{ word }}申請送出
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
export default {
  props: {
    step: VueTypes.number.def(1),
    isAtmRefund: {
      type: Boolean,
      default: false,
    },
    word: {
      type: String,
      default: '款',
    },
  },
}
</script>

<style scoped lang="scss">
.stepper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0px 12px;

  &__step {
    position: relative;
    z-index: 1;
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #9b9b9b;

    &.is-done {
      .stepper__step__item {
        background-color: #1da7fc;
      }
    }

    &.is-active {
      .stepper__step__item {
        background-color: #1da7fc;
      }
      .stepper__step__label {
        color: #222222;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: #d8d8d8;
      border-radius: 100%;

      img {
        width: 20px;
      }
    }
    &__label {
      padding: 8px 0 0;
      font-size: 13px;
      text-align: center;
    }
  }

  &__divider {
    position: relative;
    width: 100%;

    &:before {
      content: '';
      position: absolute;
      left: -20px;
      right: -30px;
      height: 4px;
      margin-top: -16px;
      background-image: linear-gradient(to right, #1da7fc, #d8d8d8);
    }

    &.is-pass {
      &:before {
        background-image: linear-gradient(to right, #1da7fc, #1da7fc);
      }
    }
    &.is-empty {
      &:before {
        background-image: linear-gradient(to right, #d8d8d8, #d8d8d8);
      }
    }
  }
}
</style>
